import { LoadingPage } from '@/components/ui/loading';
import { usePropertiesPage } from '../hooks/use-properties-page';
import { PropertiesView } from './properties-view';

export function PropertiesPage() {
  const state = usePropertiesPage();

  if (state.propertiesLoading) return <LoadingPage />;

  return <PropertiesView state={state} />;
}
